import { API_ENDPOINTS } from "config/apiConfig";
import {
  Delete,
  ProductCompanyFilter,
  ProductListPaginate,
} from "common/interfaces";
import { PAGINATION } from "common/enums/Pagination.enum";
import { baseApi } from "./baseApi";

export const productApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get Product Company
    getProductCompany: builder.query<
      ProductListPaginate,
      { filter?: ProductCompanyFilter; page?: number }
    >({
      query: ({ filter, page }) => ({
        url: API_ENDPOINTS.PRODUCT_LIST,
        params: {
          page: page || PAGINATION.PAGE,
          limit: PAGINATION.LIMIT,
          ...filter,
        },
      }),
      providesTags: ["Product"],
    }),

    // Delete Product Company
    deleteProductCompany: builder.mutation<Delete, React.Key[]>({
      query: (codes) => ({
        url: API_ENDPOINTS.DELETE_PRODUCT,
        method: "DELETE",
        body: { codes },
      }),
      invalidatesTags: ["Product"],
    }),

    // Download CSV
    downloadProductCompanyCsv: builder.mutation<
      Blob,
      { filter: ProductCompanyFilter; fileName: string }
    >({
      query: ({ filter, fileName }) => ({
        url: API_ENDPOINTS.PRODUCT_CSV,
        method: "GET",
        params: filter,
        responseHandler: async (response) => {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          return blob;
        },
      }),
    }),
  }),
});

export const {
  useGetProductCompanyQuery,
  useDeleteProductCompanyMutation,
  useDownloadProductCompanyCsvMutation,
} = productApi;
